export function getOperatorSuggestions(options, value) {
	if (!value) {
		return [];
	}

	const inputValue = value.trim().toLowerCase();
	const inputCode = value.toUpperCase();
	const inputLength = inputValue.length;
	return inputLength === 0
		? []
		: options
				.filter((option) => {
					if (option.iata_code === inputCode) {
						return true;
					}
					if (option.icao_code === inputCode) {
						return true;
					}

					return option.name.toLowerCase().indexOf(inputValue) !== -1;
				})
				.valueSeq()
				.sortBy((option) => {
					if (option.iata_code === inputCode) {
						return "0";
					}
					if (option.icao_code === inputCode) {
						return "1";
					}
					return option.name;
				})
				.take(20)
				.toArray();
}
